// extracted by mini-css-extract-plugin
export default {"container":"PortalNoElementFound__container__tfCBA","text":"PortalNoElementFound__text__KzrJD"};